import LazyLoad from "vanilla-lazyload";

// require("es6-promise").polyfill();
// require("isomorphic-fetch");
// import $ from "jquery";

export default function ScrollLoad(container) {
  const loadContainer = container;
  const preloader = loadContainer
    .closest(".media-previews-list")
    .querySelector(".js-scroll-load-preloader");
  const dataUrl = loadContainer.getAttribute("data-url");
  let inProgress = false;
  let startFrom = 15;

  window.addEventListener("scroll", function scrollPage() {
    // const scrolledY = window.pageYOffset || document.documentElement.scrollTop;
    // const loadContainerScrollTop = loadContainer.getBoundingClientRect().top;
    const loadContainerScrollBottom = loadContainer.getBoundingClientRect()
      .bottom;

    /* console.log(
      "scroll",
      document.documentElement.scrollTop,
      scrolledY,
      "scrollEl",
      loadContainerScrollBottom,
      document.documentElement.clientHeight,
      loadContainerScrollBottom - document.documentElement.clientHeight - 80
    ) */

    const scrollToLoadContainer =
      loadContainerScrollBottom - document.documentElement.clientHeight - 80;

    const tabsContainer = loadContainer.closest(".js-tab-content");

    if (tabsContainer) {
      if (
        scrollToLoadContainer < 0 &&
        !inProgress &&
        tabsContainer.classList.contains("is-show")
      ) {
        inProgress = true;
        contentRequest(dataUrl, startFrom);
      }
    } else if (scrollToLoadContainer < 0 && !inProgress) {
      inProgress = true;
      contentRequest(dataUrl, startFrom);
    }
  });

  function contentRequest(url, countStartItem) {
    const params = `start-from=${countStartItem}`;
    const dataContent = new FormData();
    dataContent.append("json", JSON.stringify(params));

    /* $.ajax({
      type: "POST",
      url,
      dataType: "json",
      data: dataContent,
      cache: false,
      contentType: false,
      processData: false,

      success(data) {
        console.log("success");
        handleResponse(data);
      },
      error() {
        console.log("fail");
      }
    }); */

    fetch(url, {
      method: "POST",
      body: dataContent,
      credentials: "same-origin"
    })
      .then(function requestSuccess(response) {
        // console.log("resp", response);
        if (response.ok) {
          return response.json();
        }

        if (response.status === 404) {
          if (!preloader.classList.contains("is-hidden")) {
            preloader.classList.add("is-hidden");
            // console.log("hidden-3");
          }
        }

        throw new Error("Network response was not ok.");
      })
      .then(function requestResponse(jsonData) {
        if (!preloader.classList.contains("is-hidden")) {
          preloader.classList.add("is-hidden");
          // console.log("hidden-2");
        }

        handleResponse(jsonData);
      });
  }

  function handleResponse(content) {
    if (content.countItems && content.countItems === 15) {
      startFrom += content.countItems;
      updateItemsBlock(content.items);

      inProgress = false;
    } else {
      /* preloader none */
      if (!preloader.classList.contains("is-hidden")) {
        preloader.classList.add("is-hidden");
        // console.log("hidden-1");
      }

      updateItemsBlock(content.items);

      inProgress = true;
    }
  }

  // console.log("startFrom", startFrom);

  function updateItemsBlock(content) {
    const loadWrapper = loadContainer.querySelector(
      ".js-scroll-load-add-element-wrapper"
    );

    if (loadWrapper) {
      // console.log("loadWrapper", loadWrapper, content);
      loadWrapper.innerHTML = content;
      if (
        loadWrapper.classList.contains("js-scroll-load-add-element-wrapper")
      ) {
        loadWrapper.classList.remove("js-scroll-load-add-element-wrapper");
      }

      const wrapper = document.createElement("div");
      loadContainer.appendChild(wrapper);

      wrapper.classList.add(
        "media-previews-list__add-items",
        "js-scroll-load-add-element-wrapper"
      );
    }

    // console.log("inProgress", inProgress, startFrom);

    // eslint-disable-next-line no-new
    new LazyLoad({
      container: loadContainer,
      elements_selector: ".js-lazy-img"
    });

    // eslint-disable-next-line no-new
    new LazyLoad({
      container: loadContainer,
      elements_selector: ".js-lazy-img-webp",
      to_webp: true
    });
  }
}
